export const PATH = {
  home: "/",
  portfolio: "/portfolio",
  blogs: "/blogs",
};
